import { Box } from "@mui/material";
import type React from "react";
import AttachmentsSection from "../advertisement/AttachmentsSection.tsx";
import AttributesSection from "../advertisement/AttributesSection.tsx";
import ContactsSection from "../advertisement/ContactsSection.tsx";
import Header from "../advertisement/Header.tsx";
import ImagesSection from "../advertisement/ImagesSection.tsx";
import { MainInfoSection } from "../advertisement/MainInfoSection.tsx";
import AdAdditionalInfo from "../advertisement/main-info-section/AdAdditionalInfo.tsx";
import { DetailQrCode } from "../DetailQrCode.tsx";

export interface AdDetailPreviewProps {
	id: number;
}

export const AdDetailPreview: React.FC<AdDetailPreviewProps> = ({ id }) => {
	return (
		<Box
			sx={{
				containerName: "ad-detail",
				containerType: "inline-size",
			}}
		>
			<Header id={id} />
			<ImagesSection id={id} />
			<MainInfoSection id={id} />
			<AttributesSection id={id} />
			<AdAdditionalInfo id={id} />
			<ContactsSection id={id} />
			<AttachmentsSection id={id} />
      <DetailQrCode />
    </Box>
	);
};